import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { removeCitations } from "@/modules/chat/chat.utils";
import { GridSidebarSearchRowActions } from "@/modules/snapshots/grid/sidebar/search/rowActions";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
}

export const GridSidebarSearchRow: React.FC<Props> = ({ businessReportOutcome }) => (
  <>
    <td className="py-4 pl-4 pr-3 text-sm sm:pl-6" title={businessReportOutcome.name}>
      <div className="font-medium text-gray-900">{businessReportOutcome.name}</div>
      <div className="mt-2 text-sm text-gray-500">{removeCitations(businessReportOutcome.answer)}</div>
      {businessReportOutcome.fs_entry && (
        <div className="mt-2 text-sm text-gray-400">{businessReportOutcome.fs_entry.document_name}</div>
      )}
    </td>
    <td className="whitespace-nowrap pl-3">
      <GridSidebarSearchRowActions businessReportOutcome={businessReportOutcome} />
    </td>
  </>
);
